import { useAuth } from "@library/Security";
import { ApiBase } from "@library/Security/Types/ApiBase";
import { User, type IUserApi, type IUserDto } from ".";
import type { IActiveVehicleDto } from "./IActiveVehicle";

/**
 * Accessor to obtain an Api with strongly typed user
 * @returns An Api object with strongly typed User
 */
export const useApi = (): IUserApi => useAuth().api as any;

/**
 * The Api implementation, with key functionality derived from ApiBase
 */
export class Api extends ApiBase<User>
{
    
    /**
     * Called by the auth service to retrieve a user object that implements IApiUser
     * @param model 
     * @returns 
     */
    createUser( model: IUserDto, fullResponse?: any )
    {
        // If the authentication response includes a vehicle, sync it to local storage.
        // Some auth library calls pass a reduced payload here after JupiterProps has
        // already saved the vehicle, so only clear the value when the response
        // explicitly includes a null vehicle.
        if( Object.prototype.hasOwnProperty.call( fullResponse ?? {}, 'vehicle' ) )
        {
            if( fullResponse.vehicle )
            {
                this.saveActiveVehicle( fullResponse.vehicle );
            }
            else
            {
                localStorage.removeItem( 'activeVehicle' );
            }
        }

        return new User( model );

    }

    /**
     * Occurs on login
     * @param user 
     */
    onLogin( user: User )
    {
    }

    /**
     * Occurs on logout
     */
    onLogout()
    {
    }

    /**
     * Occurs when the welcome flow on login has been finalized
     */
    onFinalizeLogin()
    {
    }

    /**
     * Saves the activeVehicle to local storage
     * @param model 
     */
    private saveActiveVehicle( model: IActiveVehicleDto )
    {
        localStorage.setItem( 'activeVehicle', JSON.stringify( model ) );
    }

}
